/* XPlamps 2.0 — 全站基础 JS（归属 A）。section 私有脚本放各自文件。 */
(function () {
  // 进场：首屏内元素静止可见，其余滚入视口时抬起
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.remove('is-pending');
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.xp-reveal').forEach(function (el) {
    if (el.getBoundingClientRect().top > window.innerHeight) {
      el.classList.add('is-pending');
      io.observe(el);
    }
  });

  // 全站事件约定（B 的 header / cart-drawer 监听这些）：
  //   cart:open           打开购物车抽屉
  //   cart:add  {detail:{id, quantity, properties}}  加购（cart.js 实现，成功后自己触发 cart:updated 并打开抽屉）
  //   cart:updated {detail:{cart}}  购物车变化后广播，header 角标据此刷新
  window.XP = window.XP || {};
  window.XP.emit = function (name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  };
  // Inbox is fixed over the page. On phones, keep its launcher off shopping
  // controls as content scrolls or changes; the open conversation stays usable.
  var phone = window.matchMedia('(max-width: 959px)');
  var chatFrame = 0;
  var chatHost = null;
  var chatRoot = null;
  var chatParts = new MutationObserver(queueChatCheck);
  var actions = 'a[href], button, input, select, textarea, summary, label, [role="button"], main p, main h1, main h2, main h3, .xp-pdp__form, .shopify-payment-button, shopify-accelerated-checkout, .xp-pdp__offers, .xp-pdp__price, .xp-trust, .xp-pay, .xp-footer__payments';
  function checkChat() {
    chatFrame = 0;
    var overlaps = false;
    var host = document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    if (host !== chatHost || root !== chatRoot) {
      chatParts.disconnect();
      chatHost = host;
      chatRoot = root;
      if (root) chatParts.observe(root, { childList: true, subtree: true });
    }
    var launcher = root && root.querySelector('[part~="activator"]');
    if (phone.matches && launcher && document.elementsFromPoint) {
      var rect = launcher.getBoundingClientRect();
      if (rect.width > 0 && rect.height > 0) {
        // Hit testing avoids measuring every catalog card on every scroll.
        // Hidden launchers keep their box, so the result remains stable.
        var fractions = [0.04, 0.5, 0.96];
        overlaps = fractions.some(function (fx) {
          return fractions.some(function (fy) {
            return document.elementsFromPoint(rect.left + rect.width * fx, rect.top + rect.height * fy).some(function (el) {
              return el !== host && !host.contains(el) && !!el.closest(actions);
            });
          });
        });
      }
    }
    document.body.classList.toggle('xp-chat-overlaps-action', overlaps);
  }
  function queueChatCheck() {
    if (!chatFrame) chatFrame = window.requestAnimationFrame(checkChat);
  }
  window.addEventListener('scroll', queueChatCheck, { passive: true });
  window.addEventListener('resize', queueChatCheck, { passive: true });
  document.addEventListener('load', queueChatCheck, true);
  document.addEventListener('cart:updated', queueChatCheck);
  document.addEventListener('shopify:section:load', queueChatCheck);
  document.addEventListener('transitionend', queueChatCheck, true);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', queueChatCheck, { passive: true });
    window.visualViewport.addEventListener('scroll', queueChatCheck, { passive: true });
  }
  new MutationObserver(queueChatCheck).observe(document.body, { childList: true, subtree: true });
  var stickyBar = document.querySelector('.xp-pdp__bar');
  if (stickyBar) new MutationObserver(queueChatCheck).observe(stickyBar, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(queueChatCheck).observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
  if (document.fonts) document.fonts.ready.then(queueChatCheck);
  // Inbox may attach its shadow tree after the host is inserted.
  window.addEventListener('load', queueChatCheck);
  if (window.customElements) window.customElements.whenDefined('shopify-chat').then(queueChatCheck);
  queueChatCheck();
})();
